@if (showHeaderContent) {
    @if (tabs.length > 1) {
        <ds-segmented-control
            msThemedSegmentedControl
            [themeInverse]="segmentedControlThemeInverse"
            [fullWidth]="false"
            (activeOptionChange)="tabSelectedmedia($event)">
            @for (tab of tabs; track $index) {
                <ds-segmented-option [name]="tab.id" [title]="tab.title">
                    <ng-template #dsTemplate>
                        <vn-icon size="14" [name]="tab.icon"></vn-icon>
                    </ng-template>
                </ds-segmented-option>
            }
        </ds-segmented-control>
    }
} @else {
    <div class="stats-icon">
        <div class="icon">
            @if (hasStats) {
                <div (click)="activateMedia($event, mediaType.Stats)">
                    <vn-icon class="media-stats-icon" size="16" [name]="stats"></vn-icon>
                </div>
            }
        </div>
    </div>
    <div class="media media-animation-icon">
        <div class="icon">
            @if (hasAnimation) {
                <div (click)="activateMedia($event, mediaType.Animation)">
                    <vn-icon size="16" [name]="animation"></vn-icon>
                </div>
            }
        </div>
    </div>
    <div class="media media-video-icon">
        <div class="icon">
            @if (hasVideo) {
                <div (click)="activateMedia($event, mediaType.Video)">
                    <vn-icon size="16" [name]="video"></vn-icon>
                </div>
            }
        </div>
    </div>
}
